import { render } from "./speakers.vue?vue&type=template&id=55033056&scoped=true"
import script from "./speakers.vue?vue&type=script&lang=js"
export * from "./speakers.vue?vue&type=script&lang=js"

import "./speakers.vue?vue&type=style&index=0&id=55033056&lang=scss&scoped=true"
import "./speakers.vue?vue&type=style&index=1&id=55033056&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-55033056"

export default script